import React from "react";

import Tasks from "../../Tasks";
import { useTaskNavigationCompat } from "../taskNavigationContext";

import TaskDetailsStandaloneV3 from "./TaskDetailsStandaloneV3";

interface TaskDetailsProps {
  disableDrawerTransition?: boolean;
}

const TaskDetails: React.FC<TaskDetailsProps> = ({
  disableDrawerTransition = false,
}) => {
  const { handleNavigateToTasksList } = useTaskNavigationCompat();

  return (
    <Tasks>
      <TaskDetailsStandaloneV3
        disableDrawerTransition={disableDrawerTransition}
        onDrawerExited={handleNavigateToTasksList}
      />
    </Tasks>
  );
};

export default TaskDetails;
